export const getStylesFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  
  return {
    // Colors
    primaryColor: params.get('primaryColor') || '#3b82f6',
    backgroundColor: params.get('backgroundColor') || '#ffffff',
    textColor: params.get('textColor') || '#000000',
    borderColor: params.get('borderColor') || '#e5e7eb',
    eventBackgroundColor: params.get('eventBgColor') || '#93c5fd',
    
    // Typography
    fontFamily: params.get('fontFamily') || 'system-ui',
    fontSize: params.get('fontSize') || '14px',
    
    // Layout
    borderRadius: params.get('borderRadius') || '8px',

    // Card Layout
    cardsPerRow: parseInt(params.get('cardsPerRow') || '4', 10),
    cardWidth: params.get('cardWidth') || '250px',
    cardGap: params.get('cardGap') || '16px'
  };
};